import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './block-person.scss';

class BlockPerson extends PureComponent {
  render() {
    const { image, name, company, email, phone } = this.props.content;

    return (
      <div className="block-person">
        <div className="person-content">
          {(!!image) &&
            <img src={image} alt={name}/>
          }

          <div className="person-info">
            <h4 dangerouslySetInnerHTML={{ __html: name }} />
            <p dangerouslySetInnerHTML={{ __html: company }} />
          </div>
        </div>

        {(!!phone || !!email) &&
          <div className={cn('person-contacts', { 'has-image': !!image })}>
            {(!!phone) &&
              <a href={`tel:${phone}`}>{phone}</a>
            }

            {(!!email) &&
              <a href={`mailto:${email}`}>{email}</a>
            }
          </div>
        }
      </div>
    );
  }
}

BlockPerson.propTypes = {
  content: PropTypes.shape({
    image: PropTypes.string,
    name: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired
  })
};

export default BlockPerson;



// WEBPACK FOOTER //
// ./src/components/widgets/StaticRenderer/BlockPerson.js